import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { NOTIFICATIONS_URL, MESSAGING_URL } from 'global-constants';

import {
  fetchConversations,
  fetchAndGroupUnseenMessages
} from 'pages/Messaging/ducks';

import WithPush from 'shared/HOCs/WithPush';

import AlertIndicator from 'shared/components/AlertIndicator';

import styles from './styles.module.scss';

class GlobalNotifier extends React.Component {
  componentDidMount() {
    // Make sure unread messages counter will be up to date when user navigates the site.
    this.props.fetchAndGroupUnseenMessages({
      message: null,
      conversation_id: null
    });
  }

  redirectToMessaging = () => {
    this.props.push(MESSAGING_URL);

    this.props.fetchConversations();
  };

  redirectToNotifications = () => this.props.push(NOTIFICATIONS_URL);

  render() {
    const { unseenMessageCount, notificationAlertCount } = this.props;

    return (
      <div className={styles.container}>
        <Link
          to={MESSAGING_URL}
          className={styles.item}
          onClick={this.redirectToMessaging}>
          <div className="material-icons">mail_outline</div>
          <AlertIndicator className={styles.alertCount}>
            {unseenMessageCount}
          </AlertIndicator>
        </Link>

        <Link
          to={NOTIFICATIONS_URL}
          className={styles.item}
          onClick={this.redirectToNotifications}>
          <div className="material-icons">notifications_none</div>
          <AlertIndicator className={styles.alertCount}>
            {notificationAlertCount}
          </AlertIndicator>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { unseenMessageCount } = state.pages.messaging.globalNotifier;

  return {
    unseenMessageCount
  };
};

const mapDispatchToProps = {
  fetchConversations,
  fetchAndGroupUnseenMessages
};

export default WithPush(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(GlobalNotifier)
);
